import {createSlice} from "@reduxjs/toolkit";
import {json} from "../../lib/appfuse-react/core/json";
import {Questionnaire} from "../../lib/appfuse-react/qnr";

const name = 'inbox';

const initialState = {
    data: [],
    selection: [],
    pageNumber: 0,
    pageSize: 10,
    criteria: {},
    sort: null,
    drafts: {},
    nodeIds:{},
    questionnaire:null,
    questionnaireActiveStep: 0
};

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setData(state, action) {
            state.data = json.toJSON(action.payload);
        },
        setSelection(state, action) {
            state.selection = action.payload;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
        },
        setCriteria(state, action) {
            state.criteria = action.payload;
        },
        setSort(state, action) {
            state.sort = action.payload;
        },
        setNodeIds(state, action) {
            state.nodeIds = action.payload;
        },
        setQuestionnaire(state, action) {
            const questionnaire =  json.toJSON(action.payload);
            state.questionnaire = questionnaire;
        },
        setQuestionnaireActiveStep(state, action) {
            state.questionnaireActiveStep = action.payload;
        },
        setDrafts(state, action) {
            state.drafts = json.toJSON(action.payload);
        }
    }
})

export const { setData, setSelection, setPageNumber, setPageSize, addDraft, setNodeIds, setDrafts, setQuestionnaire, setQuestionnaireActiveStep } = slice.actions;
export const { reducer } = slice;

export const selectData = state => json.fromJSON(state[name].data);
export const selectSelection = state => state[name].selection;

export const selectPageNumber = state => state[name].pageNumber;
export const selectPageSize = state => state[name].pageSize;
export const selectCriteria = state => state[name].criteria;
export const selectDrafts = state => json.fromJSON(state[name].drafts);
export const selectDraft =  (key) => (state) => selectDrafts(state)[key];
export const selectNodeIds = state => json.fromJSON(state[name].nodeIds);
export const selectNodeId = key => state => selectNodeIds(state)[key];
export const selectQuestionnaire = state =>  json.fromJSON(state[name].questionnaire, Questionnaire);
export const selectQuestionnaireActiveStep = state => state[name].questionnaireActiveStep;

export const setDraft = (key, draft) => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    drafts[key] = draft;
    dispatch(setDrafts(drafts));
}

export const setNodeId = (key, nodeId) => (dispatch, getState) => {
    const nodeIds = selectNodeIds(getState());
    nodeIds[key] = nodeId;
    dispatch(setNodeIds(nodeIds));
}

export const removeDraft = key => (dispatch, getState) => {
    const drafts = selectDrafts(getState());
    delete drafts[key];
    dispatch(setDrafts(drafts));
}

const inboxReducer = reducer;
export default inboxReducer;

